import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AddNode, AddWorkstationDTO } from 'src/app/core/models/node';
import { NodeService } from 'src/app/core/services/node.service';
import { BulkAddUserComponent } from 'src/app/modules/user/modals/bulk-add-user/bulk-add-user.component';
import { saveAs } from 'file-saver';
import { PlatformTypes } from 'src/app/core/models/globals';

@Component({
  selector: 'app-import-nodes',
  templateUrl: './import-nodes.component.html',
  styleUrls: ['./import-nodes.component.scss']
})
export class ImportNodesComponent implements OnInit {

  fileName: string ;
  importArray: AddNode[] = [];
  @ViewChild('fileUpload') fileUpload;

  constructor(
    public dialog: MatDialogRef<BulkAddUserComponent>,
    private snackBar: MatSnackBar,
    private _nodeService: NodeService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      importType: string,
      requiredParams: string,
      uniqueFields: string
    },
  ) {}

  ngOnInit(): void {}

  onClose() {
    this.dialog.close(false);
  }

  onSubmit() {
    if (this.importArray.length > 0) {
      this.importArray.forEach(arr => {arr.SkipCloudDeployment = true; arr.NodeType = "3" })
      this._nodeService.addNode(this.importArray).subscribe({
        next: (data: any) => {
          this.snackBar.open(data.actionMessage, 'Ok', {
            duration: 5000
          })
        }, error: (err) => {
          this.snackBar.open(err.error.actionMessage, "Ok", {
            duration: 5000
          })
        }
      })
      this.snackBar.open("Import workstations is in progress", "Ok", {
        duration: 5000
      })
      this.dialog.close(true);
    }
  }

  onFileSelected(event){
    const file:File = event.target.files[0];
    if(file){
      try {
        this.importArray.length = 0;
        this.fileName = file.name;
        let reader: FileReader = new FileReader();
        reader.readAsText(file);
        reader.onload = (e) => {
          let csv: string = reader.result as string;
          csv = csv.trim()
          let csvToRowArray = csv.split("\r\n").filter(e => !e.includes(",,,,,"));
          let headers = csvToRowArray[0].split(",").map(a => a?.split(" (")[0].trim());
          let props = Object.getOwnPropertyNames(new AddWorkstationDTO());
          for (let index = 1; index < csvToRowArray.length; index++) {
            let row = csvToRowArray[index].split(",");
            let user = Object.create(AddWorkstationDTO)
            props.forEach((prop, i) => {
              Object.assign(user, { [prop] : row[this.getIndexOfString(prop.toLowerCase(), headers)] })
            });
            this.importArray.push(user)
          }
        }
      } catch (error) {
        this.importArray = [];
        this.snackBar.open("Error reading contents of file.")
      }
    }
  }

  getIndexOfString(value, array: string[]){
    return array.findIndex(a => a.toLowerCase() == value)
  }

  onFileChange(){
    this.fileUpload.nativeElement.value = "";
  }

  downloadTemplate(){
    let headers = this.data.requiredParams.split(",");
    const header = headers;
    let csv = ["workstation1,10.0.0.10,,,,5"];
    csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');

    var blob = new Blob([csvArray], {type: 'text/csv' })
    saveAs(blob, `ImportWorstationData.csv`);
  }
}
